module.exports = __webpack_public_path__ + "img/6f0840b3f2313ce9b48881d368f517a3.07538a06.png";